import {Injectable} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {SplashScreen} from '@capacitor/splash-screen';

@Injectable({
  providedIn: 'root'
})
export class SplashScreenManagerService {

  /**
   * Ocultar el splash screen
   *
   */
  public async hide() {

    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await SplashScreen.hide();

    } catch (error) {
      console.warn('Error to hide splash:', error);
    }
  }
}
